import { DepartureHit } from "@wojo/services";
import { parseAsBoolean, useQueryStates } from "nuqs";
import React from "react";
import { parseAsEncodedString } from "../../search-params";
import { DepartureListDateCell } from "./DepartureListDateCell";
import { DepartureListFlexCell } from "./DepartureListFlexCell";
import { DepartureListPriceCell } from "./DepartureListPriceCell";
import styles from "./TripBuilderDeparturesStep.module.scss";

type DepartureListRowProps = {
    departure: DepartureHit;
};

export const DepartureListRow: React.FC<DepartureListRowProps> = ({
    departure,
}) => {
    const [filterStates] = useQueryStates({
        priceWithFlights: parseAsBoolean,
        priceWithFlightsGateway: parseAsEncodedString,
    });
    const gateway =
        filterStates.priceWithFlights && filterStates.priceWithFlightsGateway;
    const price =
        (gateway && departure.gatewayPricing?.[gateway]?.price) ||
        departure.price;
    const salePrice =
        (gateway && departure.gatewayPricing?.[gateway]?.salePrice) ||
        departure.salePrice;
    const discountAmount =
        (gateway && departure.gatewayPricing?.[gateway]?.discountAmount) ||
        departure.discountAmount;

    return (
        <tr className={styles["departure-row"]}>
            <DepartureListDateCell departure={departure} />
            <DepartureListFlexCell departure={departure} />
            <DepartureListPriceCell
                fullPrice={price}
                onSale={departure.isOnSale}
                salePrice={salePrice}
                discountAmount={discountAmount}
            />
        </tr>
    );
};
